import { chirpGateways, createChirpFetch, loadBalancers } from 'chirp-fetch';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import { streamAiResponseRpc as streamAiResponsePublicRpc } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc';
import { streamAiResponseRpc } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { useAppContext } from '../../context/AppContext';
const STREAM_TIMEOUT_MS = 30000;
const appChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.APP
});
const publicChirpFetch = createChirpFetch({
  loadBalancer: loadBalancers.APP,
  gateway: chirpGateways.EXTERNAL
});
export const appStreamClient = createRpcClientV2({
  hubHttpClient: http,
  fetchClient: appChirpFetch
});
export const publicStreamClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
  fetchClient: publicChirpFetch
});
export function useStreamAiSummary({
  requestId,
  skip
}) {
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState(false);
  const appContext = useAppContext();
  useEffect(() => {
    if (skip || !requestId) return;
    setError(false);
    setAnswer('');
    const client = appContext === 'app' ? appStreamClient : publicStreamClient;
    const rpc = appContext === 'app' ? streamAiResponseRpc : streamAiResponsePublicRpc;
    const streamHandler = client.stream(rpc, {
      request: {
        requestId
      },
      timeout: STREAM_TIMEOUT_MS
    });
    void streamHandler.onMessage(message => {
      if (message.type === 'rpcError' || message.data.status === 'FAILURE') {
        setError(true);
        return;
      }
      const {
        delta,
        completeAnswer
      } = message.data;
      if (completeAnswer) {
        setAnswer(completeAnswer);
        return;
      }
      if (delta) {
        setAnswer(prev => prev + delta);
      }
    }).catch(() => setError(true));
    return () => {
      streamHandler.abort();
    };
  }, [requestId, skip, appContext]);
  return {
    answer,
    error
  };
}